<!--
================================================
Composant gérant le formulaire de login
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="LoginComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
        <div class="columns mainContainer">

            <div class="column"></div>
            <div class="column is-three-quarters formColumn">

                <div class="columns is-centered">

                    <div class="column is-9 columnContForm">
                        <form action="" v-on:keyup.enter="validateBeforeSubmit">

                          <div class="logo">

                            <img v-if="themeToDisplay=='dark'" src="../assets/img/AppLogoDarkMode.png" alt="Cronocloud App" width="164" height="29" class="logoImg">
                            <img v-else src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logoImg">
                          </div>

                            <h1 class="is-size-4">{{ $t("Connexion") }}</h1>

                            <div class="field">
                                <div class="control">
                                    <input class="input" v-model="email"
                                           autocomplete="username"
                                           v-validate="'required|email'"
                                           data-vv-validate-on="change" id="login_email"
                                           name="login_email" type="email" v-bind:placeholder="$t('email')">
                                </div>
                                <p class="help is-danger has-text-left" id="error_login_email">{{errors.first('login_email') }}</p>

                            </div>

                            <div class="field">
                                <div class="control">
                                    <input class="input"
                                           v-model="password" v-validate="'required|min:6|max:20'"
                                           data-vv-delay="700" id="login_password" name="login_password" type="password" v-bind:placeholder="$t('motDePasse')" autocomplete="current-password">
                                </div>
                                <p class="help is-danger has-text-left" id="error_login_password">{{
                                    errors.first('login_password') }}</p>
                            </div>
                            <router-link v-bind:to="{ name: 'password-request', query: {email:email}}" id="pwdRequestLink" class="mdpLink is-right">{{$t("motDePasseOublié")}}</router-link>


                            <div class="field">
                                <a v-on:click="validateBeforeSubmit" id="formSubmitBtn" v-bind:class="{'is-loading':isSubmiting}" class="button  is-fullwidth loginBtn">{{$t("Connexion")}}</a>
                            </div>


                            <div class="alreadySigned">
                                <span>{{$t("PasEncoreInscrit")}} </span>
                                <span>
                                    <router-link id="signupLink" v-bind:to="{ name: 'signup'}" >{{$t("Inscrivez-vous")}}</router-link>
                                </span>
                            </div>


                        </form>
                    </div>

                </div>
            </div>
            <div class="column"></div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InitialHydrationMixin from "../mixins/InitialHydrationMixin.js";
    import GoogleAnalyticsMixin from "../mixins/GoogleAnalyticsMixin.js";
    import TrackingMixin from "../mixins/TrackingMixin.js";

    export default {
        name: 'LoginComp',
        components: {
        },
        mixins: [GlobalErrorNotification, SentryMixin, InitialHydrationMixin, GoogleAnalyticsMixin, TrackingMixin],
        data: function () {
            return {

                // champs du formulaire
                email: '',
                password: '',

                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                loginFrom: '', // String (browser/pwa)
            }

        },

        methods: {

            /*
            Envoi la requête pour réaliser la connexion
            */
            sendLoginQuery(){

                let self = this
                return self.$http
                    .post("login_check", {
                        _username: self.email,
                        _password: self.password,
                    })
                    .then(function (response) {
                        if(response.status == 200){ // si credential ok, on authentifie l'utilisateur
                          self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                          self.$auth
                                    .setToken(response.data.token)
                                    .setRefreshToken(response.data.refresh_token)
                                    .setOrganization(response.data.organization)
                                    .setRoles(response.data.roles)
                                    .setUserSlug(response.data.user)
                                    .setWorkspaces(response.data.workspaces)
                                    .setActiveWorkspace(response.data.workspaces[0]) // @todo à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                                    .setActiveWorkspaceCurrency(response.data.activeWorkspace.currency) // @todo voir si à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                                    .saveCookie();

                            // on récup. et stocke l' user l'organization dans le store
                            self.userInitialHydration(self)

                          // tracking via mixpanel
                            self.$mixpanel.identify(response.data.user);  //on passe le slug utilisateur pour identifier l'user chez mixpanel
                            self.$mixpanel.people.set({
                              'Last Login Date': self.$moment().toISOString(),
                            })

                            self.logDataEvent(self,'LOGIN',[self.loginFrom])

                            self.$mixpanel.track("login");

                            // redirection vers timetracking
                            setTimeout(function() {
                                //ajout d'un délai de 1 sec. Car un bug faisait que le cookie n'avait pas le temps d'être renseigné (pour définir les liens tels ques #appMenuLinkUserSettings dans AppMenuComp) (voir cypress/integration/tests/login_spec.js:119 )

                                // on enregistre l'event dans analytics
                                self.ga4GlobalEventTrack('login' , {method:'email'})

                                self.isSubmiting = false;
                                self.$router.replace(response.data.organization+'/timeTracking')

                            }, 500);

                        }
                    })
                    .catch(function (error) {

                        // On logue les éventuelles erreurs (sauf 401 bad credential ) & on affiche une notif
                        if (error.response == undefined || error.response.status != 401) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0001'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error on login query', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error on login query"})
                            self.$sentry.captureMessage(`Error ${errorCode} > login query : ${error}`, 'error')
                        }
                        // on affiche une notification 'bad credential' en cas d'erreur 401
                        else if (error.response.status == 401){
                            self.$store.commit('UpdateGlobalNotificationComp', {
                                'isVisible': true,
                                'color': 'is-warning',
                                'message': self.$t('IdentifiantsInvalides')
                            });
                        }
                        self.isSubmiting = false;
                    }).then(() =>{
                        // toujours exécuté
                        this.isSubmiting = false;
                    })


            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        this.sendLoginQuery();
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        this.isSubmiting = false;
                    }

                })
            },

        },

      computed:{
        // computed props for store :
        ...mapState({
          themeToDisplay: state => state.app.themeToDisplay
        }),
      },

        created: function () {

        },
        mounted: function () {

          // detection utilisation depuis pwa
          if (this.pwaIsStandalone()) {
            this.loginFrom ='standalone'
            this.$gtag.set({'pwa_mode': 'standalone'})
          }
          else{
            this.loginFrom ='browser'
            this.$gtag.set({'pwa_mode': 'browser'})
          }

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #LoginComp {
      .column {
        /*border: dashed 1px red;*/
      }

      .mainContainer {
        /*border :solid 3px gold;*/
        //  box-shadow:  0 -3px 5px $brandThird;
        @include mobile {
          padding: 0 1.5rem;
          margin-top: -3rem;
        }
      }

      .formColumn {
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        .logo {
          margin-bottom: 4rem;
          //border: dashed 1px red;
          padding: 1rem 2rem;
          position: relative;
          display: inline-block;
          &:after{
            content: "Beta";
            font-size: .6rem;
            font-weight: bold;
            position: absolute;
            top:.2rem;
            right:0;
            color:#ccc;
            padding: .1rem .4rem;
          }
          @include touch{
            margin-bottom: 2.5rem;
          }
        }

        h1 {
            color: $brandThird;
            /*font-size: 2rem;*/
          @include touch{
            margin-bottom: 1rem;
          }
        }

        .input {
            margin-top: 2rem;
          @include touch{
            margin-top: 1.5rem;
          }
        }

        .loginBtn {
          margin-top: 4rem;
          padding: 2rem 0;
          border: solid 1px transparent;
          background: $brandPrimary;
          color: white;

          &:hover {
            transition: background-color 0.3s;
            background: lighten($brandPrimary, 5%);
            color: white;
          }

          &:active {
            background: $brandBlue;
            transition: background-color 0.1s;
            color: white;
          }

        }

        .mdpLink {
          text-align: right;
          display: block;
          margin: 1rem 0;
          $color: rgba(131, 155, 166, 0.51);
          color: $color;

          label {
            color: $color;
          }
        }

        .columnContForm {
            @include mobile {
                padding: 0 1rem;
            }
        }

        .alreadySigned {
          margin: 3rem 0 0;
          color: $brandBlue;

          a {
            color: $brandBlue;
            text-decoration: underline
          }

        }

      }


      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {
        .formColumn {
          background-color: rgba(#292b2b, 0.7);

          .logo {

          }

          h1 {
            color: $brandPrimary;
          }

          .input {
            background-color: $darkBg4 !important;
            border-color: $darkLightBlue;
            color:$darkContrastTxt;
            &:focus{
              box-shadow: 0 0 3px $darkBrandBlue inset;
              border-color: $darkBrandBlue;
            }
          }

          .loginBtn {
            //border: solid 1px transparent;
            background-color: $brandPrimary;
            color: $darkTxtOnPrimary;

            &:hover {
              background: lighten($brandPrimary, 5%);
              color: white;
            }

            &:active {
              background-color: $darkBrandBlue;
              color: white;
            }

          }

          .mdpLink {
            $color:darken($darkLightBlue,20%);
            color: $color;
            transition: color 200ms;
            &:hover{color:$darkLightBlue}

            label {
              color: $color;
            }
          }
          .alreadySigned{
            color:$darkLightBlue !important;
            a{color:$darkLightBlue !important;}
          }

        }

      }
    }

</style>
